import {
  Box,
  Container,
  Text,
  VStack,
  Heading,
  useColorModeValue,
} from "@chakra-ui/react";
import { ProjectGrid } from "../components/project/ProjectGrid";

export const Projects = () => {
  const textColor = useColorModeValue("gray.600", "gray.400");
  const headingColor = useColorModeValue("gray.800", "white");

  return (
    <Box as="main" py={{ base: 10, md: 16 }} px={{ base: 4, md: 0 }}>
      <Container maxW="5xl">
        <VStack align="stretch" spacing={10}>
          <VStack align="start" spacing={4} maxW="2xl">
            <Heading
              as="h1"
              size="xl"
              fontWeight="700"
              letterSpacing="-0.02em"
              color={headingColor}
            >
              Projects
            </Heading>
            <Text fontSize="md" color={textColor} lineHeight="1.7">
              I build things in my free time — from quick experiments to longer-running side
              projects. Here are some of them.
            </Text>
          </VStack>

          <ProjectGrid />
        </VStack>
      </Container>
    </Box>
  );
};
